import Icon from './Icon';
import icons from '../../markons/markons';

export default function GreyDash(props: any) {
    return <Icon name={icons.ionMinusRound} className="payment--not-set" {...props} />;
}
